import { Component, Vue } from 'vue-property-decorator'
import { validEmail, validUserName, isBetween, validPassword} from '../../../helper-functions/validators'
import textInput from '../../../components/text-input/text-input.vue'

@Component({
  components: {
    textInput,
  }
})

export default class Register extends Vue {

  private namespace: string = '/Account';

  private activationCode: string = '';

  private userId: string | null = null;

  private username: string = '';

  private company: string = '';

  private email: string = '';

  private password: string = '';

  private passwordMatch: string = '';

  private alertMessage: string = '';

  private submitted: boolean = false;

  private error: boolean = false;

  private activationKeyValid: boolean = false;

  private disabled: boolean = false;

  private get ValidPassword (): boolean {
    
    return validPassword(this.password, this.username);
  }

  private get ConfirmedPassword (): boolean {

    return this.password != '' && this.password === this.passwordMatch;
  }

  private get ValidUsername () {

    return validUserName(this.username);
  }

  private get ValidCompany () {

    return isBetween(5, 100, this.company);
  }

  private get ValidEmail () {

    return validEmail(this.email);
  }

  private get UserId (): string | null {

    return this.userId != null
      ? this.userId
      : null;  
  }

  private get enabled () {
    
    return this.ValidUsername
      && this.company != null
        && this.company !== ''
          && this.ValidUsername
            && this.ValidEmail
              && this.ValidPassword
                && this.ConfirmedPassword
                  && !this.disabled;
  }

  private beforeMount () {
    
    if (this.$route.query.activationCode) {

      this.activationCode = this.$route.query.activationCode as string;
      this.checkActivationCode(this.activationCode);
    }
  }

  private alertReset () {

    setTimeout(() => {   

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000);
  }

  private async checkActivationCode (activationCode: string) {

    try {

      const response = await this.$axios.get(`${this.$apiUrl + this.namespace}/Register`, {
        params: {activationCode: this.activationCode}
      });
      
      this.userId = response.data;

    } catch (err) {

      this.activationKeyValid = !this.activationKeyValid;
    }
  } 

  private async register () {

    this.submitted = true;

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/Register`, {
        UserId: this.userId,
        ActivationCode: this.activationCode,
        UserName: this.username,
        FullName: this.company,
        Email: this.email,
        Password: this.password
      });

      this.submitted = false;
      this.$store.commit('createSession', response.data);
      this.$router.replace({name: 'overview'});
    } catch (err) {

      this.submitted = false;
      this.error = !this.error;
      this.alertMessage = this.$t('errors.general') as string;
      this.alertReset();
    }
  }
}